import { Link } from 'react-router-dom';
import { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  size?: 'small' | 'medium' | 'large';
}

export default function ComicCard({ comic, size = 'medium' }: ComicCardProps) {
  const coverSizes = {
    small: 'w-[130px] h-[175px]',
    medium: 'w-[160px] h-[215px]',
    large: 'w-[180px] h-[240px]',
  };

  const titleSizes = {
    small: 'text-sm',
    medium: 'text-base',
    large: 'text-lg',
  };

  return (
    <Link to={`/article/${comic.id}`} className="group block">
      <div className={`${coverSizes[size]} relative overflow-hidden rounded-xl mb-3`}>
        <img
          src={comic.cover}
          alt={`${comic.title} 韩漫封面`}
          title={`${comic.title} - 韩漫全集免费阅读`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
          <span className="text-xs text-white font-medium bg-primary-500/90 px-2 py-0.5 rounded-full">
            {comic.rating} 分
          </span>
        </div>
        <div className="absolute top-2 left-2">
          <span className={`text-[10px] font-medium px-2 py-0.5 rounded-full ${comic.status === '连载中' ? 'bg-accent-500 text-background-50' : 'bg-foreground-600 text-background-50'}`}>
            {comic.status}
          </span>
        </div>
        {comic.updatedAt === '2026-08-05' && (
          <div className="absolute top-2 right-2">
            <span className="text-[10px] font-medium px-2 py-0.5 rounded-full bg-primary-500 text-background-50">
              NEW
            </span>
          </div>
        )}
      </div>
      <h3 className={`${titleSizes[size]} font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-600 transition-colors`}>
        {comic.title}
      </h3>
      <p className="text-xs text-foreground-500 mt-1 line-clamp-1">{comic.author} · {comic.totalChapters}话</p>
    </Link>
  );
}